module.exports = __webpack_public_path__ + "static/media/pause.1893a20d.webp";